import { PayloadAction } from '@reduxjs/toolkit';
import { EditorScenes, EditorState } from 'src/store/editor/types';

const setEditorScenesReducer = (state: EditorState, action: PayloadAction<EditorScenes>) => {
  state.editorScenes[`${action.payload.productUid}_${action.payload.bundledProductId}`] = action.payload;
};

export default setEditorScenesReducer;
